import * as React from "react"

import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "../../cn"

const linkVariants = cva(
  [
    "inline-flex cursor-pointer items-center gap-1 text-sm",
    "transition-colors duration-150",
    "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-coval-border-active focus-visible:ring-offset-1 focus-visible:rounded-sm",
  ],
  {
    variants: {
      variant: {
        default:
          "text-coval-text underline underline-offset-2 hover:text-coval-text-muted",
        muted:
          "text-coval-text-muted underline underline-offset-2 hover:text-coval-text",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
)

export type LinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> &
  VariantProps<typeof linkVariants> & {
    external?: boolean
  }

const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
  ({ className, variant, external, ...props }, ref) => {
    const externalProps = external
      ? { target: "_blank", rel: "noopener noreferrer" }
      : {}

    return (
      // eslint-disable-next-line jsx-a11y/anchor-has-content -- content provided via children spread
      <a
        ref={ref}
        className={cn(linkVariants({ variant, className }))}
        {...externalProps}
        {...props}
      />
    )
  },
)

Link.displayName = "Link"

export { Link, linkVariants }
